/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { IUser } from '../types/user/IUser';

export const getUserThumbnailVersion = (user: IUser | undefined) => {
  if (!user) {
    return undefined;
  }
  return [user?.firstName?.charAt(0), user?.middleName?.charAt(0), user?.lastName?.charAt(0), user.id]
    .filter(v => v)
    .join('_');
};
